import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MessageBusMessage, MessageKey } from './message-bus.model';

@Injectable({ providedIn: 'root' })
export class MessageBusService {
  private subject = new Subject<MessageBusMessage>();

  getObservable<TMessage>(key: MessageKey, partitionKey?: MessageKey): Observable<TMessage> {
    const resolvedKey = this.resolveFullMessageKey(key, partitionKey);
    return this.subject.pipe(
      filter(({ key }) => key === resolvedKey),
      map(({ payload }) => payload as TMessage),
    );
  }

  getFeedByKeyPrefix<TMessage>(partialKey: MessageKey): Observable<MessageBusMessage<TMessage>> {
    return this.subject
      .pipe(
        filter(({ key }) => key.toString().startsWith(partialKey.toString())),
        map((message:MessageBusMessage<TMessage>) => message));
  }

  sendMessage<TMessage>(key: MessageKey, data: TMessage, partitionKey?: MessageKey): void {
    this.subject.next({ key: this.resolveFullMessageKey(key, partitionKey), payload: data });
  }

  private resolveFullMessageKey(key: MessageKey, partitionKey?: MessageKey): MessageKey {
    return partitionKey ? `${partitionKey}_${key}` : key;
  }
}
